import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import strings from 'localization/strings';

import MarginBox from 'common/MarginBox';
import Caption from './Caption';
import InformationItems from './InformationItems';
import QrCodeContainer from './QrCodeContainer';
import DescriptionGivenAfterPurchase from 'account/bookings/DescriptionGivenAfterPurchase';

const InvoiceInformation = ({ purchase }) => {
    const { appContext } = useAppContext();

    const booking = purchase.booking;

    const contactUs = strings.formatString(strings.invoiceInformation.contactUs, appContext.company.customerServiceEmail, appContext.company.telephone);

    return (
        <>
            <MarginBox top={3} bottom={3}>
                <Caption text={strings.invoiceInformation.manageBookingCaption}/>
                <MarginBox bottom={2}>
                    {strings.invoiceInformation.manageBooking}
                </MarginBox>
                <MarginBox bottom={2}>
                    {strings.invoiceInformation.takeoverFirstInvoiceFeeInformation}
                </MarginBox>

                <MarginBox>
                    <QrCodeContainer
                        qrCode={booking.tenantQrCode}
                        text={strings.invoiceInformation.manageBookingCaption}
                        url={booking.tenantUrl}
                    />
                </MarginBox>
            </MarginBox>

            <MarginBox bottom={3}>
                <Caption text={strings.contactUs}/>
                <MarginBox>
                    {contactUs}
                </MarginBox>
            </MarginBox>

            <InformationItems caption={strings.yourBooking} purchase={purchase} />

            {booking.descriptionGivenAfterPurchase && <MarginBox top={3}><DescriptionGivenAfterPurchase booking={booking} /></MarginBox>}
        </>
    );
};

InvoiceInformation.propTypes = {
    purchase: PropTypes.object.isRequired
};

export default InvoiceInformation;
